const ALLOWED_TAGS = ['b', 'strong', 'i', 'em', 'u', 'br'];

/**
 * Allows only a small whitelist of inline formatting tags (bold/italic/underline/line-break),
 * strips every attribute and any other tag. Prevents arbitrary HTML/script injection in the banner.
 */
export function sanitizeInline(input?: string | null): string {
    if (!input) {
        return '';
    }

    return input.replace(/<\/?([a-zA-Z0-9]+)(\s[^>]*)?>/g, (match, tag: string) => {
        const normalized = String(tag).toLowerCase();
        if (!ALLOWED_TAGS.includes(normalized)) {
            return '';
        }
        if (normalized === 'br') {
            return '<br/>';
        }
        return match.charAt(1) === '/' ? `</${normalized}>` : `<${normalized}>`;
    });
}
